const carousels = document.querySelectorAll('.swiper-slider');

carousels.forEach(carousel => {
    const swiper = new Swiper(carousel, {
        slidesPerView: 'auto',
        loop: true,
        navigation: {
            nextEl: carousel.querySelector('.carousel__btn-next'),
            prevEl: carousel.querySelector('.carousel__btn-prev'),
        },
        pagination: {
            el: carousel.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
});